/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_Contribute_IntroInputs */



/**
* | output |
* | --- |
* | "Help us fill in the gaps." |
*
* @param {Layout_Header_Contribute_IntroInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_contribute_intro = /** @type {((inputs?: Layout_Header_Contribute_IntroInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_Contribute_IntroInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Hilf uns, die Lücken zu füllen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aidez-nous à combler les manques.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("帮我们把缺失的部分补齐。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("一起幫我們補齊缺漏。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("빈 곳을 함께 채워 주세요.")
	return /** @type {LocalizedString} */ ("Help us fill in the gaps.")
});